import { render, staticRenderFns } from "./Project.vue?vue&type=template&id=068eab06&scoped=true"
var script = {}
import style0 from "./Project.vue?vue&type=style&index=0&id=068eab06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068eab06",
  null
  
)

export default component.exports